export const SALES_FUNNELS_API = '/api/dashboard/customer/membership/courses/filter/sales-funnel'
export const SALES_FUNNEL_STEP_API =
  '/api/dashboard/customer/membership/courses/filter/sales-funnel-step'
